<template>
  <div class="fu-drtab" data-test="fu-drawer-insurance">
    <p v-if="!plans.length" class="fu-drtab__empty" data-test="fu-drawer-insurance-empty">No insurance on file in Open Dental.</p>
    <div v-for="p in plans" :key="p.rank" class="fu-drins" data-test="fu-drawer-insurance-plan">
      <div class="fu-drins__rank">{{ p.rank }}</div>
      <div class="fu-drins__carrier">{{ p.carrier }}</div>
      <div v-if="p.pct !== null" class="fu-drins__bar" role="img" :aria-label="`${p.pct}% of the annual maximum used`">
        <span :style="{ width: `${p.pct}%` }"></span>
      </div>
      <dl class="fu-drins__grid">
        <div><dt>Annual max</dt><dd>{{ p.max }}</dd></div>
        <div><dt>Used</dt><dd>{{ p.used }}</dd></div>
        <div><dt>Remaining</dt><dd class="fu-drins__rem">{{ p.rem }}</dd></div>
      </dl>
    </div>
  </div>
</template>

<script>
/**
 * DrawerInsuranceTab — "Insurance": today's Insurance Info (recall only — the other queues load no
 * insurance; drawerTabs leaves the tab out there): primary and secondary, carrier, annual max, used,
 * remaining, with the design's used bar (teal). Presentational.
 */
const RANK = ['Primary', 'Secondary'];

export default {
  name: 'DrawerInsuranceTab',
  props: {
    tab: { type: Object, required: true },
    ctx: { type: Object, required: true },
  },
  computed: {
    plans() {
      const s = (this.tab.sections || [])[0];
      if (!s || s.shown === false) return [];
      return (s.rows || []).slice(0, 2).map((r, i) => {
        const max = Number(r.annualMax);
        const used = Number(r.amountUsed);
        const pct = Number.isFinite(max) && max > 0 && Number.isFinite(used) ? Math.max(0, Math.min(100, Math.round((used / max) * 100))) : null;
        const money = v => (v === null || v === undefined || v === '' ? '—' : this.ctx.formatMoney(v));
        return { rank: RANK[i], carrier: r.insurance || '—', max: money(r.annualMax), used: money(r.amountUsed), rem: money(r.amountRemaining), pct };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './drawer';

.fu-drtab__empty { @include fu-dr-empty; }

.fu-drins {
  margin-top: 14px;
  padding: 14px 16px;
  border: 1px solid $fu-border;
  border-radius: 12px;
}

.fu-drins__rank { @include fu-eyebrow($fu-text-muted); }
.fu-drins__carrier { margin-top: 4px; font-size: 15px; font-weight: 800; overflow-wrap: anywhere; }

.fu-drins__bar {
  height: 8px;
  margin-top: 14px;
  border-radius: 6px;
  background: $fu-neutral-100;
  overflow: hidden;
  span { display: block; height: 100%; border-radius: 6px; background: $fu-brand-400; }
}

.fu-drins__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin: 10px 0 0;
  dt { font-size: 11.5px; font-weight: $fu-fw-regular; color: $fu-text-subtle; }
  dd { @include fu-tabular; margin: 2px 0 0; font-size: 14px; font-weight: $fu-fw-bold; }
}

.fu-drins__rem { color: $fu-brand-700; }
</style>
